import { AppShell, useMantineColorScheme } from "@mantine/core";
import { useLayout } from "@layout";
import Header from "./header/header.jsx";
import Content from "./content/Content.jsx";
import Navbar from "./navbar/navbar.jsx";
import { useTrans } from "core/index.js";
export default function Layout() {
	const { mobileOpened, desktopOpened, options } = useLayout(); /* prettier-ignore */
	const { colorScheme } = useMantineColorScheme();
	const isDark = colorScheme === "dark";
	const menu = [];
	const { t } = useTrans();
	try {
		const archRaw = typeof window !== "undefined" ? localStorage.getItem("architecture") : null;
		if (archRaw) {
			const arch = JSON.parse(archRaw);
			const forms = arch.forms || [];
			const mapping = {
				homePage: { label: t("drawer.homePage"), path: "/", icon: "Home" },
				regionPage: { label: t("drawer.regionPage"), path: "/region", icon: "MapMarkerOutline" },
				configPage: { label: t("drawer.configPage"), path: "/config", icon: "Cogs" },
				unPublishedPage: { label: t("drawer.unPublishedPage"), path: "/unpublished", icon: "FileClockOutline" },
				ownsPage: { label: t("drawer.ownsPage"), path: "/owns", icon: "HomeCityOutline" },
				ConfirmReservePage: { label: t("drawer.ConfirmReservePage"), path: "/confirm-reserve", icon: "Check" },
				featuresPage: { label: t("drawer.featuresPage"), path: "/features", icon: "Star" },
				ReportPage: { label: t("drawer.ReportPage"), path: "/report", icon: "FileChart" },
				cancelConfirmedPage: {
					label: t("drawer.cancelConfirmedPage"),
					path: "/cancel-reserve",
					icon: "CloseCircleOutline",
				},
			};
			for (const f of forms) {
				if (mapping[f]) menu.push(mapping[f]);
			}
		}
	} catch (e) {
		console.warn("failed to build menu from architecture", e);
	}
	return (
		<AppShell
			style={{ height: "100vh" }}
			layout="alt"
			padding={"md"}
			header={{ ...options.header }}
			navbar={{
				width: 300,
				breakpoint: "sm",
				collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
			}}
		>
			<AppShell.Header withBorder={false} bg={isDark ? "darkColor.4" : "lightColor.0"}>
				<Header />
			</AppShell.Header>

			<AppShell.Navbar withBorder={false}>
				<Navbar menu={menu} />
			</AppShell.Navbar>

			<AppShell.Main style={{ overflowY: "auto" }} bg={isDark ? "darkColor.6" : "lightColor.0"}>
				<Content />
			</AppShell.Main>
		</AppShell>
	);
}
